import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { ApiIntegration } from '../../_services/api.integration';
import { Router } from '@angular/router';
import { AlertService } from '../../_services/alert.service';
import { saveAs } from 'file-saver';
import { ExcelServiceService } from '../../_models/excel-service.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-invoices',
  templateUrl: './admin-invoices.component.html',
  styleUrls: ['./admin-invoices.component.css']
})
export class AdminInvoicesComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  deleteApiPop: string = 'N';
  tabClicked: string = "";
  invoice: any;
  statusText: string;
  invoiceData: any = {
    companyName: "",
    ownerName: "",
    email: "",
    mobile: "",
    addressText: "",
    invoiceNum: "",
    invoiceDate: "",
    invoiceType: "",
    paymentStatus: "",
  };
  invoiceLinesVal: any;
  invoices: any;
  invoiceId: number;
  totalAmount: number;
  //openPopup: string = "";
  companyName: string = "";
  ownerName: string = "";
  mobile: number;
  email: string = "";
  exampleModalPreview: string = "";
  addressText: string = "";
  errorMessage: string;
  checkedList: any;
  masterSelected: boolean = false;
  previousStatus = '';
  invoiceStatus: any = 'ALL';
  totalRecords: number;
  userDrop2: any = 'ALL';
  accountOwners: any;
  accountOwner: any;

  constructor(private alertService: AlertService, private http: HttpClient, private excelService: ExcelServiceService, private g: Globals, public user: User, private api: ApiIntegration, private router: Router) {
    this.g.page = "Invoices";
    // this.api.getInvoicesList("PAID").subscribe((data:any)=> {this.invoice= data; }, err=> {console.log(err);});
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      if (this.tabClicked === 'unPaid') {
        this.populateTabData('unPaid', "UNPAID");

      } else if (this.tabClicked == 'paid') {
        this.populateTabData('paid', "PAID");
      }
    } else {
      this.populateTabData('all', "ALL");

    }

  }

  populate(orderChange) {
    this.api.getPaymentStatus("1", orderChange).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.invoice = data.invoiceData;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }

  showInvoiceById(invoice) {
    this.g.loaderDisplay = "display";
    this.api.getInvoicesById(invoice.id).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.invoiceData = data;
      this.invoiceLinesVal = this.invoiceData.invoiceLinesList;
      this.totalAmount = this.invoiceLinesVal.invoiceAmount
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });
  }

  showInvoiceList() {
    this.g.loaderDisplay = "display";
    this.api.getInvoicesList("WORK_ORDER").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.invoice = data;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  invoiceList(status) {

    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Invoice Number'
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.invoiceStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.invoiceStatus;
        }
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/getInvoicesList';
        let query: any = {
          paymentStatus: this.invoiceStatus,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        if (this.user.role == 'ACCOUNT_OWNER') {
          query.accountOwnerId = this.user.accountOwnerId;
        } else {
          apiMethod = 'api/getAllInvoicesByOrgIdAndPaymentStatus/1/' + this.invoiceStatus;
          delete query.paymentStatus;
          delete query.organizationId;
        }
        this.g.loaderDisplay = "display";

        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.invoice = resp.invoiceData;
            this.g.loaderDisplay = "";
            this.totalRecords = resp.noOfRecords;
            this.invoice.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfRecords,
              recordsFiltered: resp.noOfRecords
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };
  }

  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.invoice, 'sample');
  }

  checkUncheckAll() {
    for (var i = 0; i < this.invoice.length; i++) {
      this.invoice[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.invoice.length; i++) {
      if (this.invoice[i].isSelected) {
        this.checkedList.push(this.invoice[i]['id']);
      }
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }

  editInvoicePaymentStatus(invoice) {
    this.checkedList = [];
    let i = 0;
    let ohid;
    for (let inv of invoice) {
      if (inv.isSelected) {
        i = i + 1;
        ohid = inv.id;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/paymentStatus/' + ohid]);
    } else {
      this.errorMessage = "Can not Edit multiple Invoice at once. Please select one at a time";
    }
  }

  editInvoicePaymentProcess(invoice) {
    this.checkedList = [];
    let i = 0;
    let ohid;
    for (let inv of invoice) {
      if (inv.isSelected) {
        i = i + 1;
        ohid = inv.id;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/paymentProcessing/' + ohid]);
    } else {
      this.errorMessage = "Can not Edit multiple Invoice at once. Please select one at a time";
    }
  }

  populateTabData(triggered, invoiceStatus) {
    this.tabClicked = triggered;
    this.invoiceStatus = invoiceStatus;
    if (!this.previousStatus) {
      this.invoiceList(invoiceStatus);
    } else {
      this.rerender();
    }

  }

  customSearchAccountOwner(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.ownerName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }

  ngOnInit(): void {
  }

  openPopupKyc() {
    this.deleteApiPop = 'Y';
    this.api.getAccountOwners("1", "ACTIVE").subscribe((data: any) => {
      this.accountOwners = data.getAccountOwnersResponses;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  closePopup() {
    this.deleteApiPop = 'N';
    this.accountOwner = '';
  }

  openPopup() {
    this.deleteApiPop = 'Y';
  }

  generateInvoice() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createInvoiceForAccountOwner?accountOwnerId=' + this.accountOwner + '&organizationId=' + this.user.organizationId, {},
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Invoices', 'Generated successfully');
          //this.deleteApiPop = 'N';
          this.closePopup();
        } else {
          this.g.loaderDisplay = "";
        }

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(true);
    });
  }
}

